import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSzakfelelosById } from "../apis/SzakokFinder";
import { LanguageProvider, useLanguage } from "../context/LanguageContext";
import "../routes/AlapadatokView.css";
import SideTile from "../components/SideTile";
import { ALAPADATOK_VIEW_TRANSLATIONS } from "./AlapadatokViewTranslations";

const AlapadatokViewContent = () => {
    const { language, loading } = useLanguage();
    const t = loading ? ALAPADATOK_VIEW_TRANSLATIONS.hu : (ALAPADATOK_VIEW_TRANSLATIONS[language] || ALAPADATOK_VIEW_TRANSLATIONS.hu);

    const [isSideTileVisible, setIsSideTileVisible] = useState(true);

    const { szakId } = useParams();
    const [alapadatok, setAlapadatok] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchAlapadatok = async () => {
            try {
                const alapadatokResponse = await getSzakfelelosById(szakId);
                setAlapadatok(alapadatokResponse.data.data);
            } catch (error) {
                console.error("Failed to fetch alapadatok:", error);
            }
        };

        fetchAlapadatok();
    }, [szakId]);

    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/kepzes-celja`);
    };

    return (
        <div className="alapadatok-view uj-szak-page">
            <div className="uj-szak-container">
                <h1>{t.pageTitle}</h1>
                {!alapadatok ? (
                    <p>{t.loading}</p>
                ) : (
                    <div className="card">
                        <div className="data-row">
                            <div className="label">{t.kepzesNeve}</div>
                            <div className="value">{alapadatok.kepzes_neve}</div>
                        </div>
                        <div className="data-row">
                            <div className="label">{t.kepzesiSzint}</div>
                            <div className="value">{alapadatok.kepzesi_szint}</div>
                        </div>
                        <div className="data-row">
                            <div className="label">{t.kepzesiTerulet}</div>
                            <div className="value">{alapadatok.kepzesi_terulet}</div>
                        </div>
                        <div className="data-row">
                            <div className="label">{t.kreditszam}</div>
                            <div className="value">{alapadatok.kreditszam}</div>
                        </div>
                        <div className="data-row">
                            <div className="label">{t.munkarend}</div>
                            <div className="value">{alapadatok.munkarend && alapadatok.munkarend.join(", ")}</div>
                        </div>
                        <div className="data-row">
                            <div className="label">{t.kepzesiForma}</div>
                            <div className="value">{alapadatok.kepzesi_forma}</div>
                        </div>
                        <div className="data-row">
                            <div className="label">{t.specializaciok}</div>
                            <div className="value">{alapadatok.specializaciok && alapadatok.specializaciok.join(", ")}</div>
                        </div>
                        <div className="data-row">
                            <div className="label">{t.engedelySzam}</div>
                            <div className="value">{alapadatok.engedelyszam}</div>
                        </div>
                        <div className="data-row">
                            <div className="label">{t.szakInditas}</div>
                            <div className="value">{alapadatok.szak_inditas && alapadatok.szak_inditas.join(", ")}</div>
                        </div>
                        <div className="data-row">
                            <div className="label">{t.gondozoKar}</div>
                            <div className="value">{alapadatok.kepzest_gondozo_kar}</div>
                        </div>
                        <div className="data-row">
                            <div className="label">{t.gondozoTanszek}</div>
                            <div className="value">{alapadatok.kepzest_gondozo_tanszek}</div>
                        </div>
                        <div className="data-row">
                            <div className="label">{t.szakfelelosNeve}</div>
                            <div className="value">{alapadatok.szakfelelos_neve}</div>
                        </div>
                    </div>
                )}
                
                <SideTile id={szakId} texts={t.sidebar}
                isVisible={isSideTileVisible}
                /> 
                <div className="szak-button-container">
                    <button className="szak-button" onClick={handleNext}>{t.nextSection}</button>
                </div>
            </div>
        </div>
    );
};

// Wrapper component to provide LanguageContext
const AlapadatokView = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);

    useEffect(() => {
        const fetchSzakKod = async () => {
            try {
                const alapadatokResponse = await getSzakfelelosById(szakId);
                if (alapadatokResponse?.data?.data?.szak_kod) {
                    setSzakKod(alapadatokResponse.data.data.szak_kod);
                }
            } catch (error) {
                console.error("Failed to fetch szakKod:", error);
            }
        };

        fetchSzakKod();
    }, [szakId]);

    if (!szakKod) {
        return <div>Loading...</div>;
    }

    return (
        <LanguageProvider szakKod={szakKod}>
            <AlapadatokViewContent />
        </LanguageProvider>
    );
};

export default AlapadatokView;
